import { useState, useEffect } from 'react';

export const useLocalFetch = (filename) => {
    const [data, setData] = useState([]);


    useEffect(() => {
      const fetchData = async() => {
        try{
          const result = await fetch(filename)
          const data = await result.json();
          setData(data)
        } catch(e){
          console.log('Error: ', e)
        }
      };

        fetchData();
    }, [filename]);

    return (data);
}
